import React from 'react';
import Profile from './Profile';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useTranslation } from "react-i18next";

export default function EditProfile() {
  const [open, setOpen] = React.useState(false);
  const [openGroup, setOpenGroup] = React.useState(false);
  const { t } = useTranslation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenGroup(false);
  };
  
  const handleOpenGroup = () => {
    setOpenGroup(true);
  }

  return (
    <div>
      <div className="bm-item menu-item" onClick={handleClickOpen}>
        { t("menu.profile") }
      </div>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
      >
        <DialogContent>
          <Profile close={handleClose} />
        </DialogContent>
      </Dialog>
    </div>
  );
}